import { createFileRoute } from '@tanstack/react-router';
import Weekplan from '~/containers/Weekplan';

export const Route = createFileRoute('/weekplan/$year/$week/$day/{-$shiftId}')({
  component: Weekplan,
});
